<template>
  <b-button
    variant="warning"
    @click="update"
    >
    <b-icon
      icon="arrow90deg-up"
      />
      ユーザー情報を変更
  </b-button>
</template>

<script>
export default {
  data () {
    return {
      modelName: 'settings/userInfo'
    }
  },

  methods: {
    update () {
      this.$store.dispatch('modal/setUpdate', async () => {
        this.$store.dispatch('loading/show')
        const result = await this.$store.dispatch(`${this.modelName}/update`)
        this.$store.dispatch('loading/hide')

        if (result) {
          this.$store.dispatch('toast/show', {
            content: '変更が完了しました。',
            title: 'ユーザー情報の更新'
          })
        }
      })
    }
  }
}
</script>
